export const Z_INDEX = {
  TRACKER: -1,
  DROPDOWN: 1000,
} as const;

export const ID_PREFIXES = {
  AUTO_ACTION: 'auto-action-',
  INDEX_BASED: 'index-',
  MORE_MENU: 'more-actions-menu-',
} as const;

export const DATA_ATTRIBUTES = {
  ACTION_ID: 'data-action-id',
  PROCESSED: 'data-more-actions-processed',
} as const;

export const FADE_ANIMATION_DURATION = 300;
